// extracted by mini-css-extract-plugin
export var center = "_59-2";
export var clickableRow = "_59-5";
export var expandedRow = "_59-7";
export var hoverable = "_59-4";
export var left = "_59-1";
export var right = "_59-3";
export var row = "_59-0";
export var selectedRow = "_59-6";
export var summaryRow = "_59-8";